<template>
  <div id="app" v-if="dataIsReady">
    <title-setter :title="congressName" />
    <internet-explorer v-if="internetExplorer"></internet-explorer>
    <router-view v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TitleSetter from "@/components/TitleSetter";
import InternetExplorer from "@/views/InternetExplorer";

export default {
  components: {
    TitleSetter,
    InternetExplorer
  },

  data: function() {
    return {
      internetExplorer: false
    };
  },

  created() {
    this.$store.dispatch("fetchData");

    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = "/favicon.ico";
    this.browserDetector();
    document.getElementsByTagName("head")[0].appendChild(link);
  },
  computed: {
    ...mapGetters(["dataIsReady", "congressName"])
  },
  watch: {
    $route(to, from) {
      if (
        to.params.congressCode &&
        to.params.congressCode !== from.params.congressCode
      ) {
        this.$store.dispatch("fetchData", to.params.congressCode);
      }
    }
  },

  methods: {
    browserDetector() {
      // Opera 8.0+
      // eslint-disable-next-line no-unused-vars
      const isOpera =
        // eslint-disable-next-line no-undef
        (!!window.opr && !!opr.addons) ||
        !!window.opera ||
        navigator.userAgent.indexOf(" OPR/") >= 0;

      // Firefox 1.0+
      // eslint-disable-next-line no-unused-vars
      const isFirefox = typeof InstallTrigger !== "undefined";

      // Safari 3.0+ "[object HTMLElementConstructor]"
      // eslint-disable-next-line no-unused-vars
      const isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function(p) {
          return p.toString() === "[object SafariRemoteNotification]";
        })(
          !window["safari"] ||
            // eslint-disable-next-line no-undef
            (typeof safari !== "undefined" && safari.pushNotification)
        );

      // Internet Explorer 6-11
      const isIE = /* @cc_on!@ */ false || !!document.documentMode;

      // Edge 20+
      const isEdge = !isIE && !!window.StyleMedia;

      // Chrome 1 - 71
      // eslint-disable-next-line no-unused-vars
      const isChrome =
        !!window.chrome &&
        (!!window.chrome.webstore || !!window.chrome.runtime);

      // Blink engine detection
      // const isBlink = (isChrome || isOpera) && !!window.CSS;

      if (isIE || isEdge) {
        this.internetExplorer = true;
      }
    }
  }
};
</script>

<style lang="scss">
@media screen and (max-device-width: 1200px) {
  html,
  body {
    font-size: 12px;
  }
}

/* layout */

section {
  margin: 10px 20px;
}

.filter-trigger,
.bp-dropdown__btn {
  border: none;
  color: $primary-black;
  background: lightgray;
  font-weight: bold;
  border-radius: 5px;
  width: 187px;
  height: 45px;
  padding: 15px 20px 15px 50px !important;
  font-size: 14px;
  cursor: pointer;
}

.filter-trigger::placeholder {
  color: $primary-black;
  font-weight: bold;
  font-size: 14px;
  font-family: "Source Sans Pro", sans-serif;
}

.bp-dropdown__btn {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 1440px) {
  .bp-dropdown__btn {
    width: 50px;
    padding: 0 !important;
  }
}

.bp-dropdown__body {
  margin-top: 10px;
  border-radius: 5px;
  padding: 15px;
  p {
    margin-bottom: 25px;
  }
}

.is-big-bp__body {
  min-width: 320px !important;
  text-align: left;
}

.hotel-name-bp__body {
  max-height: 550px;
  //min-height: 200px;
  width: 250px;
  padding: 0;
}

.is-scrollable-bp__body {
  padding: 0;
  height: 200px;
  overflow: scroll;
}

.asd__wrapper,
.asd__wrapper--datepicker-open {
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  margin-top: 10px;
  border: none !important;
}

.asd__keyboard-shortcuts-trigger {
  display: none;
}

.asd__day--enabled {
  border: none !important;
}

.asd__day,
.asd__day--enabled,
.asd__day--disabled {
  width: 20px !important;
  height: 20px !important;
}

.asd__selected-date-one {
  border-radius: 5px 0 0 5px !important;
}

.asd__selected-date-two {
  border-radius: 0 5px 5px 0 !important;
}

.asd__month-table {
  border-top: 1px solid #d8d8d8;
  margin-top: 40px !important;
}

.asd__day-button {
  font-size: 12px !important;
}

@media only screen and (min-width: 768px) {
  .asd__change-month-button > button {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .asd__action-buttons {
    display: none;
  }
}

.asd__action-buttons button {
  font-size: 12px;
  padding: 10px 0;
  color: #a8a8a8;
}

.asd__action-buttons button:nth-child(2) {
  color: white !important;
  background-color: var(--congress-color);
  border-radius: 5px;
  padding: 10px 30px;
}

.asd__day--in-range,
.asd__day--selected {
  button {
    text-decoration: none !important;
  }
}

.slider {
  width: 100%;
}

.vue-slider-tooltip,
.initial-distance {
  font-weight: lighter;
  font-size: 16px !important;
}

.vue-slider {
  height: 4px !important;
  background-color: #a8a8a8 !important;
}

.vue-slider-always .vue-slider-dot {
  top: -5px !important;
}

.initial-distance {
  margin-bottom: 30px;
}

.vue-slider-tooltip {
  right: -25px;
  position: absolute;
  top: -20px !important;
}

.vue-slider-component
  .vue-slider-tooltip-top
  .vue-merged-tooltip
  .vue-slider-tooltip:before,
.vue-slider-component
  .vue-slider-tooltip-wrap.vue-slider-tooltip-top
  .vue-slider-tooltip:before {
  content: url("./assets/list-page/ic_slider.png") !important;
  color: white !important;
  position: absolute;
  bottom: 0px !important;
  left: initial !important;
  top: 19px !important;
  right: 18.5px !important;
  width: 0 !important;
  height: 0 !important;
  border: 5px solid transparent;
  border: 6px solid transparent\0;
  border-top-color: inherit;
  transform: translate(-50%);
}

.active {
  color: white;
  background-color: $primary-black;
}

.checkbox input[type="checkbox"] {
  display: none;
}

.checkbox label::before {
  content: "";
  display: inline-block;
  height: 16px;
  width: 16px;
  border: 1px solid;
}

.checkbox label::after {
  content: "";
  display: inline-block;
  height: 6px;
  width: 9px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  transform: rotate(-45deg);
}

.checkbox label {
  position: relative;
  left: 52px;
  font-size: 15px;
}

.checkbox label::before,
.checkbox label::after {
  position: absolute;
}
/*Outer-box*/
.checkbox label::before {
  top: 4px;
  left: -50px;
}
/*Checkmark*/
.checkbox label::after {
  left: -46px;
  top: 7px;
}

.checkbox-icon {
  display: inline-block;
  height: 30px;
  width: 30px;
  margin: 0 8px;
  position: absolute;
  left: -40px;
}

.checkbox input[type="checkbox"]:checked + label::before {
  background-color: $secondary-black;
}

/*Hide the checkmark by default*/
.checkbox input[type="checkbox"] + label::after {
  content: none;
}
/*Unhide the checkmark on the checked state*/
.checkbox input[type="checkbox"]:checked + label::after {
  content: "";
}

.dropdown-wrapper {
  position: relative;
}

.btn-icon {
  position: absolute;
  left: 20px;
  top: 12.5px;
  width: 20px;
  height: 20px;
  pointer-events: none;
}

@media (max-width: 1440px) {
  .btn-icon {
    left: calc(50% - 10px);
  }
}

.dropdown-title {
  font-weight: bold;
  font-size: 18px;
  color: $secondary-black;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}

.dropdown-menu {
  left: -45px !important;
  min-width: 190px !important;
}
</style>
